import { Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import MonitorWithBusinessAppIcon from "@entrilia/shared/icons/MonitorWithBusinessAppIcon.tsx";
import { BiErrorCodes } from "./BiErrorCodes.ts";

interface Props {
  errorMessage: string | undefined;
}
export default function BiErrorCodeComponent({ errorMessage, children }: PropsWithChildren<Props>) {
  if (errorMessage?.includes(BiErrorCodes.REPORT_SIZE_EXCEEDED)) {
    return (
      <Stack spacing={1} useFlexGap sx={{ flex: 1, alignItems: "center", justifyContent: "center", width: "100%" }}>
        <MonitorWithBusinessAppIcon />
        <Typography key={"REPORT_SIZE_EXCEEDED"} variant="subtitle1">
          The report output is too large to be shown
        </Typography>
        <Typography color="secondary">
          Continue configuring the report by applying additional conditions to narrow down the results.
        </Typography>
      </Stack>
    );
  }
  return <>{children}</>;
}
